@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '-';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[2], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[0], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
  }
}

import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';
import { User } from 'src/app/models/user';
import { CreditBundleTypeModel } from '../../components/settings/credits/credit-bundle-type.model';

@Component({
  templateUrl: './add-credits.modal.html',
  providers: [NgbInputDatepickerConfig,
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }]
})
export class AddCreditsModal {
  @Input('creditbundleTypes') creditbundleTypes: CreditBundleTypeModel[] = [];
  @Input('user') user!: User;
  @Output('saveCreditBundle') saveCreditBundle: EventEmitter<any> = new EventEmitter();

  model: NgbDateStruct | undefined;
  startDeadline: Date = new Date();
  minDeadline: Date = new Date(new Date().setMonth(new Date().getMonth() + 1));
  startFromDate: { year: number; month: number; day: number; };
  minFromDate: { year: number; month: number; day: number; };
  startUntilDate: { year: number; month: number; day: number; };
  minUntilDate: { year: number; month: number; day: number; };
  form!: UntypedFormGroup;
  creditbundleTypeId: number | null = null;
  validFrom: Date;
  validUntil: Date;
  AllowValidityPeriod = true;

  constructor(config: NgbInputDatepickerConfig, private activeModal: NgbActiveModal, private formBuilder: UntypedFormBuilder, _calendar: NgbCalendar) {
    this.minFromDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
    this.startFromDate = { year: new Date().getFullYear(), month: new Date().getMonth(), day: new Date().getDate() };
    this.minUntilDate = { year: this.minDeadline.getFullYear(), month: this.minDeadline.getMonth() + 1, day: this.minDeadline.getDate() };
    this.startUntilDate = { year: this.startDeadline.getFullYear() + 1, month: this.startDeadline.getMonth() + 1, day: this.startDeadline.getDate() };
    config.outsideDays = 'hidden';
    config.autoClose = 'outside';
    config.placement = ['bottom'];
    this.validFrom = new Date();
    this.validUntil = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    this.form = this.formBuilder.group({
      amount: new UntypedFormControl('', [Validators.required, CannotContainOnlySpaceValidator()]),
    });
  }

  setCreditBundleType(clickedCreditbundleType: CreditBundleTypeModel) {
    this.creditbundleTypeId = clickedCreditbundleType.id;
    this.AllowValidityPeriod = clickedCreditbundleType.allowValidityPeriod;
  }

  getCreditBundleTypeNameForChosenValue() {
    if(this.creditbundleTypes.length === 0) return "Button.Choose";
    if (this.creditbundleTypeId === null) {
      this.creditbundleTypeId = this.creditbundleTypes[0].id;
    }
    let creditbundleTypeIndex = this.creditbundleTypes.findIndex(s => s.id === this.creditbundleTypeId);
    return 'Settings.OrganisationCreditsSection.' + this.creditbundleTypes[creditbundleTypeIndex].name;
  } 

  setValidUntil(validUntil: any) {
    let dateString: string = String(validUntil);
    let dateStringArray: string[] = dateString.split('-');
    this.validUntil = new Date(Number(dateStringArray[2]), Number(dateStringArray[1]) - 1, Number(dateStringArray[0]), 12);
  }

  public getValidUntil() {
    if (this.validUntil !== null) return this.validUntil.getDate() + "-" + (this.validUntil.getMonth() + 1) + "-" + this.validUntil.getFullYear();
    return "Button.Choose";
  }

  setValidFrom(validFrom: any) {
    let dateString: string = String(validFrom);
    let dateStringArray: string[] = dateString.split('-');
    this.validFrom = new Date(Number(dateStringArray[2]), Number(dateStringArray[1]) - 1, Number(dateStringArray[0]), 12);
    this.validUntil = new Date(Number(dateStringArray[2]) + 1, Number(dateStringArray[1]) - 1, Number(dateStringArray[0]), 12);
  }

  public getValidFrom() {
    if (this.validFrom !== null) return this.validFrom.getDate() + "-" + (this.validFrom.getMonth() + 1) + "-" + this.validFrom.getFullYear();
    return "Button.Choose";
  }

  save() {
    let amount = this.form.controls['amount'].value;
    this.saveCreditBundle.emit({
      SignatureAmount: amount,
      SigningBundleTypeId: this.creditbundleTypeId,
      ValidFrom: this.validFrom ?? new Date(),
      ValidUntil: this.validUntil ?? new Date()
    });
  }

  close() {
    this.activeModal.close();
  }

}
